module.exports = __webpack_public_path__ + "img/hr-roboport-door-down.e07c9491.png";